/**
 * @generated SignedSource<<a4778ef260605ff96ee2878d84555cf5>>
 * @relayHash 7c8c189489482af15da56d7272f26902
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64

import type { ConcreteRequest } from 'relay-runtime';
export type ContentRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type LegacyMacroRendererQueryContentQuery$variables = {
  adf: string;
  containedRender?: boolean | null;
  contentId: string;
  mode?: ContentRendererMode | null;
};
export type LegacyMacroRendererQueryContentQuery$data = {
  readonly contentRenderer: {
    readonly html: string | null;
    readonly webResourceDependencies: {
      readonly contexts: ReadonlyArray<string | null>;
      readonly keys: ReadonlyArray<string | null>;
      readonly tags: {
        readonly css: string | null;
        readonly js: string | null;
      } | null;
    } | null;
  } | null;
};
export type LegacyMacroRendererQueryContentQuery = {
  response: LegacyMacroRendererQueryContentQuery$data;
  variables: LegacyMacroRendererQueryContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "adf"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "containedRender"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": "RENDERER",
    "kind": "LocalArgument",
    "name": "mode"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "adf",
        "variableName": "adf"
      },
      {
        "kind": "Variable",
        "name": "containedRender",
        "variableName": "containedRender"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "mode",
        "variableName": "mode"
      }
    ],
    "concreteType": "HtmlDocument",
    "kind": "LinkedField",
    "name": "contentRenderer",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "html"
      },
      {
        "concreteType": "WebResourceDependencies",
        "kind": "LinkedField",
        "name": "webResourceDependencies",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contexts"
          },
          {
            "kind": "ScalarField",
            "name": "keys"
          },
          {
            "concreteType": "WebResourceTags",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "js"
              },
              {
                "kind": "ScalarField",
                "name": "css"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LegacyMacroRendererQueryContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LegacyMacroRendererQueryContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7c8c189489482af15da56d7272f26902",
    "id": "86a2842e0d619c071cdb54f54bfddd7fbf88609a4d8bb58a0e80aca743392a64",
    "metadata": {},
    "name": "LegacyMacroRendererQueryContentQuery",
    "operationKind": "query",
    "text": "query LegacyMacroRendererQueryContentQuery($adf:String!,$containedRender:Boolean=false,$contentId:ID!,$mode:ContentRendererMode=RENDERER){contentRenderer(adf:$adf,containedRender:$containedRender,contentId:$contentId,mode:$mode){html,webResourceDependencies{contexts,keys,tags{js,css}}}}"
  }
};
})();

(node as any).hash = "83bbd0a93f53839a47ac4b3d948ad643";

export default node;
